"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextComponent = TextComponent;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
function TextComponent(props) {
    var size = props.size, color = props.color, weight = props.weight, uppercase = props.uppercase, center = props.center, maxLines = props.maxLines, className = props.className, label = props.label;
    var SIZE_CLASSES = {
        xsmall: "text-xs",
        small: "text-sm",
        medium: "text-base",
        large: "text-lg",
        xlarge: "text-xl",
        "2xlarge": "text-2xl",
        "3xlarge": "text-3xl",
        "4xlarge": "text-4xl",
        "5xlarge": "text-5xl",
        "6xlarge": "text-6xl",
        "7xlarge": "text-7xl",
        "8xlarge": "text-8xl",
        "9xlarge": "text-9xl",
    };
    var MAX_LINES_CLASSES = {
        infinite: "",
        one: "line-clamp-1",
        two: "line-clamp-2",
        three: "line-clamp-3",
    };
    var classNames = [
        SIZE_CLASSES[size],
        "text-".concat(color),
        weight ? "font-".concat(weight) : "",
        uppercase ? "uppercase" : "",
        center ? "text-center" : "",
        maxLines ? MAX_LINES_CLASSES[maxLines] : "",
        className !== null && className !== void 0 ? className : "",
    ]
        .filter(Boolean)
        .join(" ");
    return (0, jsx_runtime_1.jsx)(react_1.Label, { className: classNames, children: label });
}
